"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.dom = void 0;
__exportStar(require("./helper"), exports);
__exportStar(require("./interfaces"), exports);
exports.dom = require("./lib.dom");
//NOTE: For support of --no-check, see: https://github.com/asos-craigmorten/opine/issues/97#issuecomment-751806014
__exportStar(require("./EventTargetLike"), exports);
__exportStar(require("./EvtError"), exports);
__exportStar(require("./Operator"), exports);
//# sourceMappingURL=index.js.map